<template>
  <div
    style="
      width: 100%;
      margin-bottom: 0.24rem;
      border-radius: 0.08rem;
      background: #ffffff;
    "
    v-on:mouseleave="bodyMouseout"
    v-on:mouseenter="bodyMouseover"
  >
    <div class="body_m">
      <img class="body_m_img" :src="message.filePath || '../assets/LS1.png'" />
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { Axios } from "../assets/js/ls_com_axios.js";
const router = useRouter();
const from_muk_listing = ref("下架");
let iconChecked = ref(false);
const props = defineProps({
  muk_edit: {
    type: Boolean,
    // required: true
  },
  message: {},
});
</script>

<style scoped>
.body_m {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.16rem;
  position: relative;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.body_m_img {
  height: 1.66rem;
  width: 100%;
  border-radius: 0.12rem;
  /* margin: 0 auto; */
}
.body_m_left {
  flex-grow: 1;
}

.body_ml_top {
  display: flex;
}

.body_mlt_imgList {
  position: relative;
  margin-right: 0.16rem;
}

.body_mlti_bag {
  width: 0.8rem;
  height: 0.8rem;
}

.body_mlti_bottom {
  width: 0.4rem;
  position: absolute;
  top: calc(50% - 0.2rem);
  left: calc(50% - 0.2rem);
}

.body_mltt_title {
  color: #333333;
  font-size: 0.16rem;
  margin-bottom: 0.12rem;
  line-height: 0.14rem;
}

.body_mltt_title > span {
  margin-right: 0.16rem;
}

.body_mltt_videoNumber {
  color: #86909c;
  font-size: 0.12rem;
  margin-bottom: 0.08rem;
}

.body_mltt_number {
  display: flex;
}

.body_mltt_number > img {
  width: 0.16rem;
  margin-right: 0.04rem;
}

.body_mltt_number > span {
  margin-right: 0.17rem;
}

.body_ml_bottom {
  /* margin-top: 0.16rem; */
}

.body_ml_bottom > span {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #f2f3f5;
  color: #86909c;
  line-height: 0.14rem;
  font-size: 0.12rem;
  padding: 0.04rem 0.12rem;
  margin-right: 0.12rem;
  margin-top: 0.12rem;
  display: inline-block;
}

.body_mr_top {
  display: flex;
  justify-content: end;
}

.body_mr_top > img {
  width: 0.24rem;
}

.body_mr_bottom {
  display: flex;
  align-items: center;
  margin-top: 0.16rem;
}

.body_mrb_img {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  border: 0.01rem solid #c01a26;
  padding: 0.07rem;
}

.body_mrb_img > img {
  width: 0.24rem;
}

.body_mrb_bottom {
  margin-left: 0.16rem;
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  padding: 0.08rem 0.3rem;
  color: #ffffff;
  font-size: 0.14rem;
}

.SLCB_list_top_definition_list {
  position: absolute;
  top: 0.15rem;
  right: 0.17rem;
  aspect-ratio: 1 / 0.748;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.SLCB_list_top_definition_list > img {
  width: 0.24rem;
  background: #fff;
  border-radius: 0.02rem;
  padding: 0.02rem;
}

.SLCB_functionList {
  position: absolute;
  bottom: -1.25rem;
  left: -0.75rem;
  background: #fff;
  box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(32, 40, 58, 0.25);
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  padding: 0.04rem;
  width: 1rem;
  z-index: 0;
}

.SLCB_functionList > div {
  display: block;
  color: #333333;
  font-size: 0.12rem;
  text-align: center;
  padding: 0.06rem 0;

  border-radius: 0.02rem 0.02rem 0.02rem 0.02rem;
}
.dialog_b {
  margin-top: 0.2rem;
  display: flex;
  justify-content: center;
}

.dialog_b_qx {
  padding: 0.08rem 0.3rem;
  background: #fff;
  border: 0.01rem solid #333333;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  margin-right: 0.2rem;
  color: #333333;
  font-size: 0.14rem;
}

.dialog_b_qd {
  color: #ffffff;
  font-size: 0.14rem;
  padding: 0.08rem 0.3rem;
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  padding: 0.08rem 0.3rem;
}
</style>
